import { getCompanyList } from "@/spz-api/companies/companies";
import type { GetCompanyListParams } from "@/spz-api/model";
import {
  type CompanyListItem,
  CompanyMapper,
  type ControlCompanyListItem,
  ControlCompanyMapper,
} from "../../models/company.model";
import type { ICompanyRepository } from "../interfaces/company-repository.interface";

export class CompanyRepository implements ICompanyRepository {
  async getControlCompanies(
    params: GetCompanyListParams,
  ): Promise<ControlCompanyListItem[]> {
    const response = await getCompanyList(params);
    return ControlCompanyMapper.toControlCompanyListItems(response.data);
  }
  async getCompanies(): Promise<CompanyListItem[]> {
    const response = await getCompanyList();
    return CompanyMapper.toCompanyListItems(response.data);
  }
}
